import { ArrowLeft, User } from "lucide-react";
import { PublicHeaderWrapper } from "../../../_theme/layout/publicPagesComponent/HeaderWrapper";
import CustomFormInput from "../../modules/apps/components/CustomFormInput";
import { useCallback, useState } from "react";
import { ForgotPasswordAPI } from "../core/request";
import { useSnackbar } from "../../../_theme/context/SnackbarContext";
import { getApiErrorMessage } from "../../../utils/utils";

import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { BackgroundVideo } from "./Component/backgroundVideo";


/* =========================
   Validation Schema
========================= */
const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string().trim()
        .required("Email is required"),
});

/* =========================
   Main Component
========================= */
const ForgotPassword: React.FC = () => {
    const { showSnackbar } = useSnackbar();
    const Navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const handleSubmit = useCallback(async (values: { email: string; }) => {
        const payload: { email: string; } = {
            email: values.email,
        };
        setLoading(true);
        try {
            const response = await ForgotPasswordAPI(payload);
            if (response.status === "ok") {
                Navigate("/auth/login");
                showSnackbar(response.message, "success");
            } else {
                showSnackbar(response.message || "Something went wrong", "danger");
            }
        } catch (error) {
            console.error("Forgot Password error:", error);
            showSnackbar(getApiErrorMessage(error, "Forgot Password failed"), "danger");
        } finally {
            setLoading(false);
        }
    }, [showSnackbar]);

    return (
        <div className="position-relative vh-100 overflow-hidden">
            <PublicHeaderWrapper />
            <BackgroundVideo />

            <div className="d-flex flex-column justify-content-center align-items-center vh-100 position-relative">
                <div className="public-pages-container overflow-y-auto overflow-sm-hidden p-0">
                    <div className="row px-2 px-xl-20 px-md-10 align-items-center">

                        {/* LEFT SIDE */}
                        <div className="col-12 col-md-5 pe-xl-20 px-sm-20 px-md-0  p-0 align-items-center d-flex flex-column">
                            <div className="login-card d-flex flex-column justify-content-center align-items-center w-100 gap-5">
                                <p className="fw-bold fs-3 text-center mb-0">
                                    Reset Password
                                </p>

                                {/* FORMIK FORM */}
                                <Formik
                                    initialValues={{
                                        email: "",
                                    }}
                                    validationSchema={ForgotPasswordSchema}
                                    onSubmit={handleSubmit}
                                >
                                    {({ setFieldValue, values }) => (
                                        <Form className="w-100 d-flex flex-column">
                                            <div className="mb-4">
                                                <label className="form-label login-field-label mb-1">Email:</label>
                                                <CustomFormInput
                                                    placeholder="Enter your Email"
                                                    type="text"
                                                    name="email"
                                                    className="form-control"
                                                    value={values.email || ""}
                                                    disabled={loading}
                                                    prepend={<User size={16} />}
                                                    onChange={(e) => setFieldValue("email", e.target.value)}
                                                />
                                                <ErrorMessage name="email" component="div" className="text-danger small mt-1" />
                                            </div>
                                            {/* Submit Button */}
                                            <button
                                                type="submit"
                                                className="rounded-pill login-btn w-100"
                                                disabled={loading}
                                            >
                                                {loading ? "Sending in..." : "Send Reset Link"}
                                            </button>
                                            <div className="mt-8 text-center">
                                                <p className="mb-0"><Link to="/auth/login" className="auth-link fw-bold"><ArrowLeft size={16} /> Back to Login</Link></p>
                                            </div>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </div>

                        {/* RIGHT SIDE */}
                        <div className="col-12 col-md-7 ps-xl-20 px-md-10 ps-0 d-none d-md-block">
                            <p className="login-title text-center">
                                One Platform. One Province. One Future.
                            </p>
                            <p className="text-center login-subtitle">
                                Step into the future with us and experience a vision of our 2050 infrastructure excellence.
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;